import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import Moment from "moment";
import { SingleDatePicker } from "react-dates";
import Http from "axios";
import ReactTooltip from "react-tooltip";
import config from "../config";

@inject("CartStore", "UserStore")
@observer
class CartProduct extends Component {
	state = {
		startDateFocused: false,
		endDateFocused: false
	};

	componentDidMount() {
		ReactTooltip.rebuild();
	}

	async selectWaiver(item, selected) {
		await this.props.updateCartDate({}, { selectedWaiver: selected });
		this.props.CartStore.modifyItem(item, { selectedWaiver: selected });
	}

	selectQty(item, qty) {
		this.props.CartStore.modifyItem(item, { qty });
	}

	async loadMonthRentals(date, key) {
		const {
			fetchedMonths = [],
			product,
			occupiedDates,
			pendingDates
		} = this.props.cartDate;
		const weekDay = Moment(date).format("dddd");
		if (fetchedMonths.indexOf(weekDay) === -1) {
			const [
				{ data: occupiedData },
				{ data: pendingData }
			] = await Promise.all([
				Http.get(`${config.api}/products/${product._id}/occupied/${date}`),
				Http.get(`${config.api}/products/${product._id}/pending/${date}`)
			]);
			await this.handleDateChange(
				"occupiedDates",
				{ ...occupiedDates, ...occupiedData.result },
				key
			);
			await this.handleDateChange(
				"pendingDates",
				{ ...pendingDates, ...pendingData.result },
				key
			);
			await this.handleDateChange(
				"fetchedMonths",
				[...fetchedMonths, weekDay],
				key
			);
		}
	}

	async setDateFocus(fieldName, { focused }, key) {
		console.log("setDateFocused", focused);
		if (focused) {
			await this.loadMonthRentals(Moment().toISOString(), key);
		}
		this.setState({
			[fieldName]: focused
		});
	}

	async handleDateChange(fieldName, value, key) {
		const {
			CartStore,
			cartDate,
			modifyLockedDates,
			updateCartDate
		} = this.props;
		if (fieldName === "startDate" || fieldName === "endDate") {
			const modifiedCart = CartStore.items.map((item, itemKey) => {
				if (itemKey === key) {
					const newItem = {
						...cartDate,
						[fieldName]: value
					};
					const datesSet = !!newItem.startDate && !!newItem.endDate;

					console.log("Dates set?", datesSet, fieldName, value);
					console.log("New item dates:", newItem.startDate, newItem.endDate);

					if (datesSet) {
						const startDateMoment = Moment(newItem.startDate);
						const endDateMoment = Moment(newItem.endDate);
						const days = endDateMoment.diff(startDateMoment, "days");

						console.log("days", days);

						return {
							...item,
							days
						};
					}

					return item;
				}

				return item;
			});

			console.log(modifiedCart);

			CartStore.setCart(modifiedCart);
		}

		const { startDate, endDate } = {
			...cartDate,
			[fieldName]:
				fieldName === "startDate" || fieldName === "endDate"
					? Moment(value).toISOString()
					: value
		};

		const highlightUpdate =
			startDate && endDate ? { highlighted: this.isRangeHighlighted() } : {};
		const blockedUpdate =
			startDate && endDate ? { blocked: this.isRangeBlocked() } : {};

		await updateCartDate({
			[fieldName]:
				fieldName === "startDate" || fieldName === "endDate"
					? Moment(value).toISOString()
					: value,
			...highlightUpdate,
			...blockedUpdate
		});

		if (fieldName === "startDate" || fieldName === "endDate") {
			if (cartDate.locked) {
				modifyLockedDates(startDate, endDate);
			}
		}
	}

	isRangeHighlighted = () => {
		const { pendingDates, startDate, endDate } = this.props.cartDate;
		const startDateMoment = Moment(startDate);
		const endDateMoment = Moment(endDate);
		const pending = pendingDates
			? Object.values(pendingDates).reduce((pending, date) => {
					if (!pending) {
						const compareDate = Moment(date);
						return compareDate.isBetween(startDateMoment, endDateMoment);
					} else {
						return pending;
					}
			  }, false)
			: false;
		return pending;
	};

	isRangeBlocked = () => {
		const { occupiedDates, startDate, endDate } = this.props.cartDate;
		const startDateMoment = Moment(startDate);
		const endDateMoment = Moment(endDate);
		const occupied = occupiedDates
			? Object.values(occupiedDates).reduce((occupied, date) => {
					if (!occupied) {
						const compareDate = Moment(date);
						return compareDate.isBetween(startDateMoment, endDateMoment);
					} else {
						return occupied;
					}
			  }, false)
			: false;
		return occupied;
	};

	getTooltipMessage = type => {
		return type === "highlighted"
			? `Someone else has requested to have this item reserved during <br>this date range, but the order has not been fully processed.<br> If a pending reservation date falls within your selected<br> range, this item will not be reserved for <br>any of the dates in the range. Instead, you will be notified <br>via email if this item becomes available on this date.`
			: type === "blocked"
			? `Unfortunately, this item is not available on one <br>or more dates in your selected range. Please choose a different <br>date range or item or contact Stareway Films for assistance <br>finding an alternative item.`
			: "";
	};

	isRangeInvalid = () => {
		const { item } = this.props;
		const { startDate, endDate } = this.props.cartDate;

		if (startDate && endDate) {
			const startDateMoment = Moment(startDate);
			const endDateMoment = Moment(endDate);
			return endDateMoment.diff(startDateMoment, "days") <= 0;
		}

		return item.days <= 0;
	};

	calculateProductPrice = () => {
		const { item, cartDate } = this.props;
		const { startDate, endDate } = cartDate;
		const startDateMoment = Moment(startDate);
		const endDateMoment = Moment(endDate);
		const days = parseInt(
			startDate && endDate
				? endDateMoment.diff(startDateMoment, "days")
				: item.days,
			10
		);
		return (
			((parseInt(days, 10) === 1
				? item.pricePerDay
				: parseInt(days, 10) === 2
				? item.pricePerDay * 1.7
				: parseInt(days, 10) === 3
				? item.pricePerDay * 1.95
				: parseInt(days, 10) >= 4 && parseInt(days, 10) <= 7
				? item.pricePerDay * 2.95
				: item.pricePerDay * 2.95 +
				  (parseInt(days, 10) - 7) * item.pricePerDay * 0.42) +
				(item.selectedWaiver ? item.price * 0.05 : 0)) *
			item.qty
		);
	};

	render() {
		const { item, productKey, updateCartDate, removeCartDate } = this.props;
		const { startDateFocused, endDateFocused } = this.state;
		const {
			startDate,
			endDate,
			occupiedDates,
			pendingDates,
			blocked,
			highlighted,
			locked
		} = this.props.cartDate;
		const invalidDate = this.isRangeInvalid();

		return (
			<div className="entry">
				<i
					className="fa fa-close"
					onClick={async () => {
						await removeCartDate(productKey);
						this.props.CartStore.removeFromCart(item);
					}}
				/>
				<div className="entry-column itm-desc">
					<img src={item.images[0]} alt="" />
					<p>{item.name}</p>
				</div>
				<div className="entry-column dmg">
					<select
						name="dmg"
						id="dmg"
						defaultValue={item.selectedWaiver ? "1" : "0"}
						value={item.selectedWaiver ? "1" : "0"}
						onChange={e =>
							this.selectWaiver(item, !!parseInt(e.target.value, 10))
						}
					>
						<option value="0">No Damage Waiver</option>
						<option value="1">Add Damage Waiver</option>
					</select>
					<div
						className="entry-column-tooltip"
						data-tip={
							"A Damage Waiver is an insurance that you can purchase from Stareway which covers all the costs for any damage done to the equipment you've rented"
						}
						data-type={blocked ? "error" : highlighted ? "warning" : ""}
					>
						<i className="fa fa-question-circle" />
					</div>
				</div>
				<div
					className={
						"entry-column date-selector " +
						(blocked ? "blocked-field" : highlighted ? "highlighted-field" : "")
					}
					data-tip={this.getTooltipMessage(
						blocked ? "blocked" : highlighted ? "highlighted" : ""
					)}
					data-type={blocked ? "error" : highlighted ? "warning" : ""}
				>
					<SingleDatePicker
						date={startDate ? Moment(startDate) : null}
						onDateChange={startDate =>
							this.handleDateChange("startDate", startDate, productKey)
						}
						onNextMonthClick={month =>
							this.loadMonthRentals(month.toISOString(), productKey)
						}
						onPrevMonthClick={month =>
							this.loadMonthRentals(month.toISOString(), productKey)
						}
						focused={startDateFocused}
						onFocusChange={dateElement =>
							this.setDateFocus("startDateFocused", dateElement, productKey)
						}
						placeholder="Start Date"
						id="example1-date"
						readOnly
						numberOfMonths={1}
						isDayHighlighted={day =>
							!!pendingDates[day.startOf("day").toISOString()]
						}
						isDayBlocked={day =>
							!!occupiedDates[day.startOf("day").toISOString()]
						}
					/>
					<div
						className="date-lock-indicator"
						onClick={() => updateCartDate({ locked: !locked })}
					>
						{locked ? (
							<i className="fa fa-lock"></i>
						) : (
							<i className="fa fa-unlock"></i>
						)}
					</div>
				</div>
				<div
					className={
						"entry-column date-selector " +
						(blocked ? "blocked-field" : highlighted ? "highlighted-field" : "")
					}
					data-tip={this.getTooltipMessage(
						blocked ? "blocked" : highlighted ? "highlighted" : ""
					)}
					data-type={blocked ? "error" : highlighted ? "warning" : ""}
				>
					<SingleDatePicker
						date={endDate ? Moment(endDate) : null}
						onDateChange={endDate =>
							this.handleDateChange("endDate", endDate, productKey)
						}
						onNextMonthClick={month =>
							this.loadMonthRentals(month.toISOString(), productKey)
						}
						onPrevMonthClick={month =>
							this.loadMonthRentals(month.toISOString(), productKey)
						}
						focused={endDateFocused}
						onFocusChange={dateElement =>
							this.setDateFocus("endDateFocused", dateElement, productKey)
						}
						placeholder="End Date"
						id="example1-date"
						readOnly
						numberOfMonths={1}
						isDayHighlighted={day =>
							!!pendingDates[day.startOf("day").toISOString()]
						}
						isDayBlocked={day =>
							!!occupiedDates[day.startOf("day").toISOString()]
						}
					/>
					<div
						className="date-lock-indicator"
						onClick={() => updateCartDate({ locked: !locked })}
					>
						{locked ? (
							<i className="fa fa-lock"></i>
						) : (
							<i className="fa fa-unlock"></i>
						)}
					</div>
				</div>
				<div className="entry-column days-selector">
					<select
						name="dmg-w"
						id="dmg-w"
						onChange={e => this.selectQty(item, parseInt(e.target.value, 10))}
						defaultValue={item.qty}
					>
						{Array.from({ length: item.productQty }).map((qty, key) => (
							<option value={key + 1} key={key + 1}>
								{key + 1}
							</option>
						))}
					</select>
				</div>
				{invalidDate ? (
					<div className="entry-column error">Invalid date range</div>
				) : (
					<div className="entry-column pri">
						${this.calculateProductPrice().toFixed(2)}
					</div>
				)}
			</div>
		);
	}
}

export default CartProduct;



// WEBPACK FOOTER //
// ./src/components/CartProduct.js